import { GenericResponse } from "./generic-response";
import { DbWorkflowInstanceInfos } from "./db-workflow-instance-infos";

export class ListWorkflowInstanceResponse extends GenericResponse<ListWorkflowInstanceResponse> {
  instances: DbWorkflowInstanceInfos[] = [];

  constructor(init?: Partial<ListWorkflowInstanceResponse>) {
    super();
    Object.assign(this, init);
  }
}
